import { Dropdown } from '@/components/Dropdown/Dropdown';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import theme from '@/theme';
import styled from '@emotion/styled';
import { MenuList, ListItemIcon as MuiListItemIcon } from '@mui/material';
import { useState } from 'react';
import {
    canBringElementsForward,
    canBringElementsToFront,
    canSendElementsBackward,
    canSendElementsToBack,
} from '../../../actions/arrange/CanMove';
import { StyledDivider } from '../../StyledDivider';
import { ArrangeItem } from './ArrangeItem';
import { BringForwardMenuItem } from './options/BringForwardMenuItem';
import { BringToFrontMenuItem } from './options/BringToFrontMenuItem';
import { SendBackwardMenuItem } from './options/SendBackwardMenuItem';
import { SendToBackMenuItem } from './options/SendToBackMenuItem';

const StyledList = styled(MenuList)`
    padding: 0;

    &:focus {
        outline: none;
    }
`;

export const ListItemIcon = styled(MuiListItemIcon)`
    min-width: 3.2rem;
`;

const ArrangeItemWrapper = styled.div<{ isActive: boolean }>`
    ${({ isActive }) => isActive && `background-color: ${theme.colors.black[200]};`}
`;

interface Props {
    inPopoverMenu?: boolean;
    anchorOrigin?: {
        vertical: 'top' | 'bottom' | 'center';
        horizontal: 'left' | 'right' | 'center';
    };
}

export const useArrangeOptionsList = () => {
    const { store } = useAdvancedEditorContext();
    const selectedElements = store.selectedElements;
    const [closed, setClosed] = useState<boolean>(true);

    const handleCloseMenu = () => {
        setClosed(true);
    };

    const handleOpenMenu = () => {
        setClosed(false);
    };

    const items = [
        { label: <BringToFrontMenuItem disabled={!canBringElementsToFront(store, selectedElements)} /> },
        { label: <BringForwardMenuItem disabled={!canBringElementsForward(store, selectedElements)} /> },
        { label: <StyledDivider /> },
        { label: <SendToBackMenuItem disabled={!canSendElementsToBack(store, selectedElements)} /> },
        { label: <SendBackwardMenuItem disabled={!canSendElementsBackward(store, selectedElements)} /> },
    ];

    return {
        closed,
        handleCloseMenu,
        handleOpenMenu,
        items,
    };
};

export const ArrangeOptionsList = ({ inPopoverMenu, anchorOrigin }: Props) => {
    const { closed, handleCloseMenu, handleOpenMenu, items } = useArrangeOptionsList();

    if (inPopoverMenu) {
        <ArrangeItemWrapper isActive={!closed}>
            <ArrangeItem inPopoverMenu={inPopoverMenu} />
        </ArrangeItemWrapper>;
    }

    return (
        <Dropdown
            width="200px"
            closed={closed}
            onOpen={handleOpenMenu}
            onClose={handleCloseMenu}
            trigger={
                <ArrangeItemWrapper isActive={!closed}>
                    <ArrangeItem inPopoverMenu={inPopoverMenu} />
                </ArrangeItemWrapper>
            }
            items={items}
            renderMenuWrapper={children => <StyledList>{children}</StyledList>}
            anchorOrigin={anchorOrigin}
        />
    );
};
